import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ThreeDCard from "./ThreeDCard";
import axios from "axios";


const ThreeDModelList = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const getModelPath = (path) => {
    if (path.startsWith("/uploads")) {
      // For newly uploaded products
      return `${process.env.REACT_APP_BACKEND_SERVER}${path}`;
    } else {
      // For old products that were maybe in 'public' or somewhere
      return `${process.env.REACT_APP_BACKEND_SERVER}/uploads/models${path}`;
    }
  };
  

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_SERVER}/api/products`)
      .then((res) => {
        console.log("res",res);
        
        setProducts(res.data);
      })
      .catch((err) => {
        console.error("Failed to load products", err);
      });
  }, []);

const handleClick = (products) => {
  console.log("models", products);

  if (products.is3D === true || products.path?.endsWith(".glb")) {
    navigate(`/3d-product/${products._id}`);
  } else {
    navigate(`/product/${products.id}`);
  }
};
  return (
    <div
      style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
    >
      {products.map((product, i) => (
        <div key={i} onClick={() => handleClick(product)}>
          <ThreeDCard {...product} />
        </div>
      ))}
    </div>
  );
};

export default ThreeDModelList;
